import { defineMessages } from 'react-intl';

export default defineMessages({
    addAnotherLink: {
        id: '_.select_payment_method.add_another_link',
        defaultMessage: 'Add another'
    },
    addAnotherText: {
        id: '_.select_payment_method.add_another_text',
        defaultMessage: 'Want to use another debit card?'
    },
    cardOption: {
        id: '_.select_payment_method.card_option',
        defaultMessage: 'Card ●●●● {cardLastDigits}'
    },
    bankAccountOption: {
        id: '_.select_payment_method.bank_account_option',
        defaultMessage: 'Account {accountNumber}'
    },
    manualPayment: {
        id: '_.select_payment_method.manual_payment',
        defaultMessage: 'Manual Bank Transfer'
    },
    truelayerRepayment: {
        id: '_.select_payment_method.truelayer_repayment',
        defaultMessage: 'Instant Bank Transfer'
    }
});
